export const navbarProps = {};
